<!--in-progress modal-->
<div *ngIf="data.isProcessing" class="confirm-dismiss-diloag">
  <div class="confirm-dialog-header flex-between-center">
    <h4 [class]="data.styleClassHeading" [ngClass]="{ 'confirm-dismiss-dialog-heading mb-0': true }" class="pt-2 pb-2">
      <span class="exclamation-triangle">
        <i class="fas fa-exclamation-triangle"></i>
      </span>
      <span class="ml-2">{{title}} in Progress</span>
    </h4>
  </div>
  <div class="confirm-dismiss-dialog-content font-ligh font-12 subtitle" [hidden]="!data?.subTitle">
    {{ data?.subTitle }}
  </div>
  <div class="confirm-dismiss-dialog-content font-12" [hidden]="data?.isHTML">
    <div class="payment-details-box pt-1 pb-1 mt-3 mb-3">
      <div class="font-gray-45">
        <!--
        <div class="rectangle col-6 col-md-5">
        </div> -->
        <div class="rectangle-row justify-content-between">
          <div class="ui-grid-col-10">
            <div class="d-flex two-col-grid">
              <div>{{type | titlecase}} Amount:</div>
              <div class="font-weight-bold">{{ data?.amount || 0 | currency : usd }}</div>
            </div>
            <div class="d-flex two-col-grid">
              <div class="mt-2">{{type | titlecase}} Status:</div>
              <div class="mt-2 red font-weight-bold">{{ status }}</div>
            </div>
          </div>
          <div class="ui-grid-col-2 align-items-center justify-content-end d-flex">
            <i class="fas fa-redo fa-2x redo pointer" (click)="checkStatus()"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <div>
        <span class="font-gray-45">A {{type}} against this RO is in progress. 
          <span>Please wait or Cancel the {{type}} to Try again.</span>
        </span>
      </div>
    </div>
  </div>

  <div class="confirm-dismiss-dialog-content font-12" [innerHTML]="data?.message" [hidden]="!data?.isHTML"></div>

  <div class="confirm-dismiss-dialog-footer flex-end-center mt-2">
    <button
      (click)="cancelPayment()"
      [ngStyle]="{
        'background-color': 'var(--alert-700)'
      }"
      class="btn btn-danger pointer btn-submit mr-2"
      id="dialog-btn-cancel"
      tooltipPosition="top"
      [pTooltip]="isCanada && type === 'payment' ? 'Transactions cannot be canceled through the AutoLeap app. Please cancel directly from the payment terminal.' : ''">
      Cancel {{type}}
    </button>
    <button
      id="dialog-btn-dismiss"
      *ngIf="data?.button?.discard?.title"
      (click)="closeDialog(false, 'discard')"
      class="btn btn-white btn-border pointer btn-submit mr-2"
      [ngStyle]="{
        'background-color': data?.button?.discard?.backgroundColor ? data?.button?.discard?.backgroundColor : '#ffffff',
        color: data?.button?.discard?.color ? data?.button?.discard?.color : '#333333'
      }"
    >
      {{ data?.button?.discard?.title }}
    </button>
    <!-- <button id="dialog-btn-success" *ngIf="data?.button?.success?.title" (click)="closeDialog(true, 'success')"
      style="height: 33px;" class="btn btn-danger px-4">
      {{data?.button?.success?.title}}
    </button> -->
    <button
      id="dialog-btn-success"
      *ngIf="data?.button?.success?.title"
      (click)="closeDialog(true, 'success')"
      class="btn btn-primary"
      [ngStyle]="{
        'background-color': data?.button?.success?.backgroundColor ? data?.button?.success?.backgroundColor : 'var(--primary-500)',
        color: data?.button?.success?.color ? data?.button?.success?.color : '#ffffff'
      }"
    >
      {{ data?.button?.success?.title }}
    </button>
  </div>
</div>
<!--confirm modal-->
<div *ngIf="!data.isProcessing" class="confirm-dismiss-diloag">
  <div class="confirm-dialog-header flex-between-center">
    <h4 [class]="data.styleClassHeading" [ngClass]="{ 'confirm-dismiss-dialog-heading mb-0': true }" class="pt-2 pb-2">
      <span class="confirmation-card">
        <i class="fas fa-credit-card" style="color: var(--primary-900)"></i>
      </span>
      <span class="ml-2">Confirm {{type}}</span>
    </h4>
    <i (click)="closeDialog(false, 'close')" class="fal fa-times close-icon pointer"></i>
  </div>
  <div [hidden]="!data?.subTitle" class="confirm-dismiss-dialog-content font-ligh font-12 subtitle">
    {{ data?.subTitle }}
  </div>
  <div [hidden]="data?.isHTML" class="confirm-dismiss-dialog-content font-12">
    <div class="pt-2 pb-1 font-gray-45">Please ensure the terminal is turned on before proceeding.</div>
    <div class="payment-details-box pt-1 pb-1 mt-3 mb-3">
      <div class="font-gray-45">
        <div class="rectangle">
          <div class="ui-grid-col-12 d-flex two-col-grid">
            <div>{{type | titlecase}} Amount:</div>
            <div class="font-weight-bold">{{ data.amount || 0 | currency : usd }}</div>
          </div>
          <div class="ui-grid-col-12 d-flex two-col-grid">
            <div class="mt-1">{{type | titlecase}} Status:</div>
            <div class="mt-1 font-weight-bold">Unpaid</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <div class="">
        <span class="font-gray-45">Request the cardholder to check terminal to confirm the {{type}} amount, proceed and swipe the card</span>
      </div>
    </div>
  </div>

  <div [hidden]="!data?.isHTML" [innerHTML]="data?.message" class="confirm-dismiss-dialog-content font-12"></div>

  <div class="confirm-dismiss-dialog-footer flex-end-center mt-2">
    <button
      (click)="closeDialog(false, 'discard')"
      [ngStyle]="{
        'background-color': data?.button?.discard?.backgroundColor ? data?.button?.discard?.backgroundColor : '#ffffff',
        color: data?.button?.discard?.color ? data?.button?.discard?.color : '#333333'
      }"
      class="btn btn-white btn-border pointer btn-submit mr-2"
      id="dialog-btn-dismiss"
    >
      cancel
    </button>
    <!-- <button id="dialog-btn-success" *ngIf="data?.button?.success?.title" (click)="closeDialog(true, 'success')"
      style="height: 33px;" class="btn btn-danger px-4">
      {{data?.button?.success?.title}}
    </button> -->
    <button
      (click)="closeDialog(true, 'success')"
      [ngStyle]="{
        'background-color': data?.button?.success?.backgroundColor ? data?.button?.success?.backgroundColor : '#00c19f',
        color: data?.button?.success?.color ? data?.button?.success?.color : '#ffffff'
      }"
      class="btn btn-primary"
      id="dialog-btn-success"
    >
      Proceed
    </button>
  </div>
</div>
